import { cn } from "../../../lib/utils";

/**
 * One-liner page description under the app header title.
 * Soft title / notice styling — noticeable but not a large page heading.
 * Optional `actions` render on the right (CTAs, badges, filters).
 */
export function WhatsAppPageIntro({ description, actions, className }) {
  if (!description && !actions) return null;

  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between animate-fade-in-up",
        className
      )}
    >
      {description ? (
        <p
          className={cn(
            "min-w-0 flex-1 text-[15px] sm:text-base font-semibold leading-snug tracking-tight",
            "text-gray-800 dark:text-gray-100",
            "pl-3 border-l-2 border-[hsl(158,48%,36%)]/70 dark:border-[hsl(158,48%,36%)]/50"
          )}
        >
          {description}
        </p>
      ) : (
        <div className="flex-1" />
      )}
      {actions ? (
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 shrink-0 sm:justify-end">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
